import { useQuery } from '@tanstack/react-query';
import { api } from '../../core/client';
import type { StaffRecord } from './workforce.types';

const WF = '/users/v1/workforce';
const KEY = ['workforce'] as const;

/** The only workforce read left (see `workforce.types.ts` for why). */
export function useStaff() {
  return useQuery({ queryKey: [...KEY, 'staff'], queryFn: () => api.get<StaffRecord[]>(`${WF}/staff`) });
}
